import Notification, { NotificationType } from 'components/notifiers/Notification';
import strings from '../../strings/strings.json';
import { theme } from 'theme';
import ScheduleIcon from 'assets/icons/navigation/ScheduleIcon';

const ScheduleCourseChargeNotifier: React.FC<{
    organisationIsSubscribed: boolean;
    button?: JSX.Element;
}> = ({ organisationIsSubscribed, button }): JSX.Element => {
    return (
        <Notification
            notificationType={NotificationType.INFO}
            title={
                organisationIsSubscribed
                    ? strings.notifiers.scheduleCourseChargeNotifier.title
                    : strings.notifiers.scheduleCourseChargeNotifier.titleWithSubscription
            }
            button={button}
            dataTestId="notification-course-schedule-charge"
        />
    );
};

const ScheduleCoursePaymentSetupNotifier: React.FC<{ action: () => void }> = ({ action }): JSX.Element => {
    return (
        <Notification
            notificationType={NotificationType.WARNING}
            title={strings.notifiers.scheduleCoursePaymentSetupNotifier.title}
            description={strings.notifiers.scheduleCoursePaymentSetupNotifier.description}
            buttonToHelp={{
                text: strings.notifiers.scheduleCoursePaymentSetupNotifier.buttonToHelp.text,
                aria: strings.notifiers.scheduleCoursePaymentSetupNotifier.buttonToHelp.aria,
                action: action,
            }}
            dataTestId="notification-setup-payment-org-admin"
        />
    );
};

const NoPaymentNotifierForTrainers: React.FC = () => (
    <Notification
        notificationType={NotificationType.WARNING}
        title={strings.notifiers.noPaymentNotifierForTrainers.title}
        description={strings.notifiers.noPaymentNotifierForTrainers.description}
        buttonToHelp={{
            text: strings.courseOverview.scheduleButton.title,
            aria: strings.courseOverview.scheduleButton.aria,
            action: () => {},
            disabled: true,
            icon: <ScheduleIcon colour={theme.blackButtonTextColour} />,
        }}
        dataTestId="notification-setup-payment-trainer"
    />
);

const FirstCourseForFreeNotifier: React.FC<{ button?: JSX.Element }> = ({ button }) => (
    <Notification
        notificationType={NotificationType.INFO}
        title={strings.notifiers.scheduleFirstCourseFree.title}
        button={button}
        dataTestId="notification-first-course-free"
    />
);

export {
    ScheduleCourseChargeNotifier,
    ScheduleCoursePaymentSetupNotifier,
    NoPaymentNotifierForTrainers,
    FirstCourseForFreeNotifier,
};
